/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import Showdown from "showdown";

const HEX_PATTERN = /#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{8})\b/g;

const markdownConverter = new Showdown.Converter({
  simplifiedAutoLink: true,
  excludeTrailingPunctuationFromURLs: true,
  strikethrough: true,
  tables: true,
  tasklists: true,
  openLinksInNewWindow: true
});

export function injectHexColorPreviews(html: any) {
  return html.replace(
    HEX_PATTERN,
    (match: any) =>
      `<span class="inline-flex items-baseline gap-[1px]"><span class="inline-block h-3 w-3 rounded border border-gray-300" style="background-color: ${match}" title="${match}"></span><span>${match}</span></span>`
  );
}

export function useMarkdownRenderer() {
  function renderMarkdown(content: any) {
    const html = markdownConverter.makeHtml(content);
    return injectHexColorPreviews(html);
  }

  return { renderMarkdown };
}
